import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import { routerShape } from 'react-router/lib/PropTypes';

import { translate as t } from '../../../lib/I18n';
import { AccountPages, GlobalModals } from '../../../constants/AppConstants';
import ModalActions from '../../../actions/ModalActions';
import OrderActions from '../../../actions/OrderActions';
import urls from '../../../urls';
import BaseModal from '../../general/BaseModal';
import BAlert, { bAlertType } from '../../general/BAlert';
import Icon from '../../general/Icon';

const DuplicateOrderModal = ({ isLoggedIn, onProceed, orderId, router }) => {
    const prefix = isLoggedIn
        ? 'payment.duplicateOrder.loggedIn'
        : 'payment.duplicateOrder.guest';

    const close = () => {
        ModalActions.close(GlobalModals.DUPLICATE_ORDER);
    };

    const handleConfirm = () => {
        close();
        if (isLoggedIn) {
            router.push(urls.location(AccountPages.ACCOUNT_ORDERS_REFUNDS));
        }
    };

    const handleProceed = () => {
        close();
        OrderActions.acknowledgeDuplicateOrder(orderId);
        onProceed();
    };

    return (
        <BaseModal
            className="modal--sm"
            titleText="payment.duplicateOrder.title"
            continueText={`${prefix}.confirm`}
            onContinue={handleConfirm}
            onClose={close}
            hideClose
            footerContent={
                <Button
                    bsStyle="default"
                    className="action-btn action-btn--secondary pull-left"
                    onClick={handleProceed}
                >
                    {t('payment.duplicateOrder.proceed')}
                </Button>
            }
        >
            <BAlert type={bAlertType.DANGER} className="padding-top">
                <p>
                    <Icon icon="error" /> {t(`${prefix}.description`)}
                </p>
            </BAlert>
        </BaseModal>
    );
};

DuplicateOrderModal.propTypes = {
    isLoggedIn: PropTypes.bool,
    onProceed: PropTypes.func.isRequired,
    orderId: PropTypes.string,
    router: routerShape,
};

export default DuplicateOrderModal;
